module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_9005.95852546.png";